import React from 'react';
import OnMount from '@atlassian/jira-common-util-op-triggers/src/on-mount/OpTrigger.tsx';
import tagMauEvent from './tag-mau-event.tsx';
import type { SubProduct } from './types.tsx';

type Props = {
	subProduct: SubProduct;
};

const TagMauEvent = ({ subProduct }: Props): React.JSX.Element => (
	<OnMount op={tagMauEvent} args={[subProduct]} />
);

export default TagMauEvent;
